var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 845,
    viewBox: "0 0 1400 845",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 845,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M808 324C812.95 324 817 328.05 817 333V512.887L814.188 509.231L737.688 410.231C735.156 406.913 731.163 405 727 405C722.837 405 718.9 406.913 716.312 410.231L669.625 470.644L652.469 446.625C649.938 443.081 645.888 441 641.5 441C637.112 441 633.062 443.081 630.531 446.681L585.531 509.681L583 513.169V513V333C583 328.05 587.05 324 592 324H808ZM592 297C572.144 297 556 313.144 556 333V513C556 532.856 572.144 549 592 549H808C827.856 549 844 532.856 844 513V333C844 313.144 827.856 297 808 297H592ZM637 405C640.546 405 644.057 404.302 647.332 402.945C650.608 401.588 653.585 399.599 656.092 397.092C658.599 394.585 660.588 391.608 661.945 388.332C663.302 385.057 664 381.546 664 378C664 374.454 663.302 370.943 661.945 367.668C660.588 364.392 658.599 361.415 656.092 358.908C653.585 356.401 650.608 354.412 647.332 353.055C644.057 351.698 640.546 351 637 351C633.454 351 629.943 351.698 626.668 353.055C623.392 354.412 620.415 356.401 617.908 358.908C615.401 361.415 613.412 364.392 612.055 367.668C610.698 370.943 610 374.454 610 378C610 381.546 610.698 385.057 612.055 388.332C613.412 391.608 615.401 394.585 617.908 397.092C620.415 399.599 623.392 401.588 626.668 402.945C629.943 404.302 633.454 405 637 405Z",
    fill: "#2F8DE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogThumbnail);
export default __webpack_public_path__ + "static/media/blog-thumbnail.0483032184f3a9793860e74fd83fa158.svg";
export { ForwardRef as ReactComponent };